"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStatusOptions = void 0;
var react_1 = require("react");
var pay_api_1 = require("@l2p/pay-api");
var next_intl_1 = require("next-intl");
var useStatusOptions = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    return (0, react_1.useMemo)(function () {
        return Object.values(pay_api_1.TransactionStatusEnum).map(function (key) { return ({
            label: t(key),
            value: key,
        }); });
    }, [t]);
};
exports.useStatusOptions = useStatusOptions;
